import { useState, useEffect } from 'react';

const SearchBar = ({ onSearch, isLoading, initialQuery = '' }) => {
    const [searchQuery, setSearchQuery] = useState(initialQuery);

    // Update searchQuery when initialQuery changes
    useEffect(() => {
        setSearchQuery(initialQuery);
    }, [initialQuery]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!isLoading) {
            onSearch(searchQuery.trim());
        }
    };

    const handleChange = (e) => {
        const value = e.target.value;
        setSearchQuery(value);
        
        if (value.trim() === '') {
            onSearch('');
        }
    };

    return (
        <div className="input-group md:mr-10 search-bar-container">
            <input
                type="text" 
                className="form-control rounded-5"
                placeholder="Search for..." 
                value={searchQuery}
                onChange={handleChange}
                onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                        handleSubmit(e);
                    }
                }}
                disabled={isLoading}
                style={{ 
                    height: '35px',
                    fontSize: '14px',
                    alignSelf: 'flex-end',
                }}
            />
            <div className="input-group-append align-self-end">
                <button 
                    className="btn u-btn-primary rounded-5"
                    type="button"
                    onClick={handleSubmit}
                    disabled={isLoading}
                    style={{ 
                        minWidth: '50px',
                        height: '35px',
                        padding: '0 15px',
                        fontSize: '14px'
                    }}
                >
                    {isLoading ? (
                        <i className="fa fa-spinner fa-spin"></i>
                    ) : 'Go!'}
                </button>
            </div>
        </div>
    );
};

export default SearchBar; 